import { useState, useEffect, useRef } from 'react';
import {
    X, CloudUpload, Layers, Home, ChevronLeft, Plus, Minus,
    Image as ImageIcon, MapPin, LocateFixed, Trash2, Search, ExternalLink, Loader2,
} from 'lucide-react';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { defaultUnitForm } from '../data/unitData';

const UnitFormPage = ({ onClose, onSave, mode, initialData }) => {
    const [formState, setFormState] = useState(initialData || defaultUnitForm);
    const [showAdvanced, setShowAdvanced] = useState(false);
    const [locating, setLocating] = useState(false);
    const [locationError, setLocationError] = useState('');
    const [addressInput, setAddressInput] = useState('');
    const [geocoding, setGeocoding] = useState(false);
    const [imageData, setImageData] = useState(null);
    const [imageViewUrl, setImageViewUrl] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [uploadingImages, setUploadingImages] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [snackbarQueue, setSnackbarQueue] = useState([]);
    const imageInputRef = useRef(null);
    const [buildings, setBuildings] = useState([]);
    const [loadingBuildings, setLoadingBuildings] = useState(true);

    useEffect(() => {
        if (initialData) {
            setFormState(initialData);
            if (initialData.unit_id) {
                // fetchImage(initialData.unit_id);
                fetchImage(initialData.unit_code);
            }
        }
        let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
        setImageViewUrl(apiPaths[0]?.IMG_API_PATH);
    }, [initialData]);

    useEffect(() => {
        let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
        setImageViewUrl(apiPaths[0]?.IMG_API_PATH);
        const fetchBuildings = async () => {

            let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
            let companyCode = localStorage.getItem("companyCode") || "-";
            let department = localStorage.getItem("currentSelectedDepartment") || "-";
            try {
                const res = await axios.get(`${apiPaths[0]?.API_CONFIG}/api/CRMTaskMainListFilter/${companyCode}/BUILDING/-/-/-/-/-/1900-01-01/1900-01-01/-/-/-`);
                const data = Array.isArray(res.data) ? res.data : [];
                setBuildings(data);
                console.log("Building List:", data)
            } catch (err) {
                console.error('Failed to fetch buildings:', err);
            } finally {
                setLoadingBuildings(false);
            }
        };
        fetchBuildings();
    }, []);

    useEffect(() => {
        console.log("building_id:", formState.building_id)
    }, [formState])

    const handleSave = async (e) => {
        e.preventDefault();

        if (!formState.unit_id) {
            showSnackbar("Unit ID is mandatory.", "error");
            return;
        }

        const now = new Date().toISOString();
        let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
        let companyCode = localStorage.getItem("companyCode") || "-";
        let department = localStorage.getItem("currentSelectedDepartment") || "-";
        let currentUserName = localStorage.getItem("currentUserName") || "-";

        const payload = [{
            mode: mode === "edit" ? "EDIT" : "ENTRY",
            cmpcode: companyCode,
            UnitID: mode === "edit" ? formState.unit_id : 0,
            BuildingID: formState.building_id || 0, //carried or should i select from ui
            UnitCode: formState.unit_code || "",
            UnitNo: formState.unit_number || "",
            UnitName: formState.unit_name || "",
            FloorNo: Number(formState.floor) || 0,
            BlockName: formState.block_tower || "",
            Wing: formState.wing || "",
            PropertyType: formState.property_type || "",
            UnitType: formState.unit_type || "",
            Category: formState.category || "",
            UsageType: formState.usageType || "",
            Bedrooms: Number(formState.bedrooms) || 0,
            Bathrooms: Number(formState.bathrooms) || 0,
            MaidRoom: formState.maid_room || false,
            Balcony: formState.balcony || false,
            Terrace: formState.terrace || false,
            StoreRoom: formState.store_room || false,
            ParkingCount: Number(formState.parking_count) || 0,
            FloorArea: Number(formState.floor_area) || 0,
            BalconyArea: Number(formState.balcony_area) || 0,
            CommonArea: Number(formState.common_area) || 0,
            TotalArea: Number(formState.total_area) || 0,
            AreaUnit: formState.area_unit || "",
            MonthlyRent: Number(formState.monthly_rent) || 0,
            AnnualRent: Number(formState.current_rent) || 0,
            SecurityDeposit: Number(formState.security_deposit) || 0,
            RentFrequency: formState.payment_frequency || "",
            ServiceCharge: Number(formState.service_charge) || 0,
            UnitStatus: formState.status || "",
            AvailabilityDate: formState.availability_date || "",
            ElectricityAccount: formState.electricity_account || "",
            WaterAccount: formState.water_account || "",
            GasAccount: formState.gas_account || "",
            DEWANo: formState.dewa_no || "",
            MakaniNo: formState.makani_no || "",
            RERAUnitNo: formState.rera_unit_no || "",
            EjariUnitNo: formState.ejari_unit_no || "",
            TitleDeedNo: formState.title_deed_no || "",
            PlotNo: formState.plot_no || "",
            UnitView: formState.unit_view || "",
            ParkingNo: formState.parking_no || "",
            ChillerType: formState.chiller_type || "",
            CoolingProvider: formState.cooling_provider || "",
            MunicipalityFeeApplicable: formState.municipality_fee_applicable || false,
            VATApplicable: formState.vat_applicable || false,
            RentalCommission: Number(formState.rental_commission) || 0,
            RenewalNoticeDays: Number(formState.renewal_notice_days) || 0,
            HasBalcony: formState.balcony || false,
            HasCentralAC: formState.has_central_ac || false,
            HasKitchen: formState.has_kitchen || false,
            HasFurnished: formState.has_furnished || false,
            HasInternet: formState.has_internet || false,
            IncomeAccount: formState.income_account || "",
            DepositAccount: formState.deposit_account || "",
            ExpenseAccount: formState.expense_account || "",
            CostCenter: formState.cost_center || "",
            Remarks: formState.notes || "",
            CompanyCode: companyCode,
            deptno: department,
            IsActive: true,
            CreatedBy: mode === "edit" ? (formState.createdBy || currentUserName) : "admin",
            CreatedDate: mode === "edit" ? (formState.createdDate || now) : now,
            ModifiedBy: mode === "edit" ? (formState.createdBy || currentUserName) : "admin",
            ModifiedDate: now || null,
        }];

        console.log("Unit Save Payload:", JSON.stringify(payload, null, 2));

        try {
            const response = await axios.post(
                `${apiPaths[0]?.API_CONFIG}/api/UnitMaster`,
                payload,
                { headers: { "Content-Type": "application/json" } }
            );

            console.log("Save Response:", response.data);
            showSnackbar(`Unit ${mode === "edit" ? "updated" : "created"} successfully!`, "success");

            if (onSave) {
                onSave(formState);
            }
        } catch (error) {
            console.error("Error saving unit:", error);
            showSnackbar("Failed to save unit: " + (error.response?.data?.message || error.message), "error");
        }
    };

    const updateField = (field, value) => {
        setFormState({ ...formState, [field]: value });
    };

    const updateNestedField = (parent, field, value) => {
        setFormState({
            ...formState,
            [parent]: {
                ...formState[parent],
                [field]: value
            }
        });
    };

    /* ---------------- Image upload ---------------- */

    const handleImageSelect = (e) => {
        const files = e.target.files;
        if (!files?.length) return;
        const newImages = Array.from(files).map((f) => ({
            id: `${Date.now()}-${Math.random()}`,
            url: URL.createObjectURL(f),
            name: f.name,
            file: f,
        }));
        setFormState((f) => ({
            ...f,
            unit_images: [...(f.unit_images || []), ...newImages],
        }));
        e.target.value = '';
    };

    const removeImage = (id) => {
        setFormState((f) => ({
            ...f,
            unit_images: (f.unit_images || []).filter((img) => img.id !== id),
        }));
    };

    /* ---------------- Server-side Image Functions ---------------- */

    const showSnackbar = (message, severity = "success") => {
        setSnackbar({ open: true, message, severity });
    };

    const queueSnackbar = (message, severity = "success") => {
        setSnackbarQueue(prev => [...prev, { message, severity }]);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar((prev) => ({ ...prev, open: false }));
        if (snackbarQueue.length > 0) {
            setTimeout(() => {
                const [next, ...rest] = snackbarQueue;
                setSnackbarQueue(rest);
                setSnackbar({ open: true, message: next.message, severity: next.severity });
            }, 300);
        }
    };

    const getImageUrl = (itemFilePath) => {
        if (!itemFilePath || typeof itemFilePath !== "string") return "";
        const normalizedPath = itemFilePath.replace(/\\/g, "/");
        const splitKey = "BONDTIME_REALESTATE_IMG/";
        const extractedFileName = normalizedPath.includes(splitKey)
            ? normalizedPath.split(splitKey)[1]
            : normalizedPath.split("/").pop();
        if (!extractedFileName) return "";
        const cleanBase = imageViewUrl?.replace(/\/$/, "") || "";
        return `${cleanBase}/BONDTIME_REALESTATE_IMG/${extractedFileName}`;
    };

    const fetchImage = async (code) => {
        let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
        let companyCode = localStorage.getItem("companyCode") || "-";
        const url = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${companyCode}/DOCIMAGE/${code}/UNITIMAGE`;

        try {
            const response = await axios.get(url);
            const imgs = (response.data || []).map((item) => {
                const relativePath = item.Imagepath.split("BONDTIME_REALESTATE_IMG")[1];
                return {
                    slno: item.slno,
                    imagePath: "\\BONDTIME_REALESTATE_IMG\\" + relativePath,
                };
            });
            setImageData(imgs);
            setCurrentImageIndex(0);
        } catch (error) {
            console.error("Error fetching unit image:", error);
            setImageData([]);
        }
    };

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    };

    const updateItemImage = async (companyCode, unitCode) => {
        try {
            const apiPaths = JSON.parse(localStorage.getItem("apiPaths")) || [];
            const BASE_URL = apiPaths[0]?.API_CONFIG;
            const response = await axios.get(
                `${BASE_URL}/api/CRMItemImageUpdate/${companyCode}/${unitCode}`
            );
            return response.data;
        } catch (error) {
            console.error("Unit image update failed:", error);
            throw error;
        }
    };

    const uploadImage = async (selectedFile, unitCode) => {
        if (!selectedFile) {
            throw new Error("No file selected");
        }

        const companyCode = localStorage.getItem("companyCode") || "-";
        const apiPaths = JSON.parse(localStorage.getItem("apiPaths")) || [];
        const base64String = await fileToBase64(selectedFile);

        const fd = new FormData();
        fd.append("DOC_CODE", unitCode || "");
        fd.append("DOC_TYPE", "UNITIMAGE");
        fd.append("file", selectedFile);
        fd.append("cmpcode", companyCode);
        fd.append("IMGBASE64", base64String);
        fd.append(
            "IMAGEPATH",
            `${apiPaths[0].IMG_SERVERPATH}\\BONDTIME_REALESTATE_IMG`
        );
        fd.append("description", "test");

        const response = await axios.post(
            `${apiPaths[0].IMG_POST_PATH}/api/Image/upload`,
            fd,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );

        await updateItemImage(companyCode, unitCode);
        return response.data;
    };

    const handlePrev = () => {
        setCurrentImageIndex((prev) =>
            prev > 0 ? prev - 1 : (imageData?.length || 1) - 1,
        );
    };

    const handleNext = () => {
        setCurrentImageIndex((prev) =>
            prev < (imageData?.length || 1) - 1 ? prev + 1 : 0,
        );
    };

    console.log("formState:", formState)

    const handleAddImage = () => {
        const unitCode = formState.unit_code;
        if (!unitCode) {
            showSnackbar("Please enter a Unit ID before uploading images.", "error");
            return;
        }

        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.multiple = true;

        input.onchange = async (e) => {
            const files = Array.from(e.target.files);
            if (files.length === 0) return;

            setUploadingImages(true);
            let successCount = 0;
            let failCount = 0;

            for (const file of files) {
                try {
                    await uploadImage(file, unitCode);
                    successCount++;
                } catch (error) {
                    console.error("Image upload failed:", error);
                    failCount++;
                }
            }

            await fetchImage(unitCode);
            setUploadingImages(false);

            if (successCount > 0) {
                showSnackbar(`${successCount} image(s) uploaded successfully!`, "success");
            }
            if (failCount > 0) {
                queueSnackbar(`${failCount} image(s) failed to upload.`, "error");
            }
        };

        input.click();
    };

    const handleRemoveItem = async () => {
        if (!imageData?.length) return;

        const currentImage = imageData[currentImageIndex];
        if (!currentImage?.slno) return;

        let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
        let companyCode = localStorage.getItem("companyCode") || "-";
        let currentUserName = localStorage.getItem("currentUserName");

        try {
            const url = `${apiPaths[0]?.API_CONFIG}/api/CRMImageDelete`;
            const payload = [
                {
                    CmpCode: companyCode,
                    mode: "DELETE",
                    docuId: currentImage.slno,
                    comments: "Image removed",
                    user: currentUserName,
                },
            ];

            await axios.post(url, payload);

            showSnackbar("Image removed successfully", "success");

            setImageData((prev) =>
                prev.filter((img) => img.slno !== currentImage.slno)
            );
            setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : 0));
        } catch (error) {
            console.error("Failed to delete image:", error);
            showSnackbar("Failed to remove image", "error");
        }
    };

    /* ---------------- Location ---------------- */

    const useCurrentLocation = () => {
        if (!navigator.geolocation) {
            setLocationError('Geolocation is not supported by this browser.');
            return;
        }
        setLocating(true);
        setLocationError('');
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                setFormState((f) => ({
                    ...f,
                    location: {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    },
                }));
                setLocating(false);
            },
            (err) => {
                setLocationError(err.message || 'Unable to fetch location.');
                setLocating(false);
            }
        );
    };

    const clearLocation = () => {
        setFormState((f) => ({ ...f, location: null }));
        setAddressInput('');
    };

    const searchAddress = async () => {
        if (!addressInput.trim()) return;
        setGeocoding(true);
        setLocationError('');
        try {
            // Nominatim (OpenStreetMap) — free, no API key required.
            // Please keep lookups light per their usage policy: https://operations.osmfoundation.org/policies/nominatim/
            const res = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(addressInput)}`
            );
            const data = await res.json();
            if (data && data.length > 0) {
                const { lat, lon, display_name } = data[0];
                setFormState((f) => ({
                    ...f,
                    location: { lat: parseFloat(lat), lng: parseFloat(lon), address: display_name },
                }));
            } else {
                setLocationError('No results found for that address.');
            }
        } catch (err) {
            setLocationError('Failed to search address. Please try again.');
        } finally {
            setGeocoding(false);
        }
    };

    const loc = formState.location;
    const mapEmbedUrl = loc
        ? `https://www.openstreetmap.org/export/embed.html?bbox=${loc.lng - 0.004}%2C${loc.lat - 0.003}%2C${loc.lng + 0.004}%2C${loc.lat + 0.003}&layer=mapnik&marker=${loc.lat}%2C${loc.lng}`
        : null;
    const googleMapsUrl = loc ? `https://www.google.com/maps?q=${loc.lat},${loc.lng}` : null;

    // Helper for checkbox fields
    const CheckboxField = ({ label, field, parent = null }) => (
        <label className="flex items-center gap-2.5 cursor-pointer group">
            <input
                type="checkbox"
                checked={parent ? formState[parent]?.[field] : formState[field]}
                onChange={(e) => {
                    if (parent) {
                        updateNestedField(parent, field, e.target.checked);
                    } else {
                        updateField(field, e.target.checked);
                    }
                }}
                className="w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500 focus:ring-offset-0 cursor-pointer"
            />
            <span className="text-sm font-medium text-slate-700 group-hover:text-slate-900">{label}</span>
        </label>
    );



    return (
        <div className="min-h-screen bg-slate-50/50 flex flex-col">
            {/* Header */}
            <div className="flex justify-between items-center gap-2.5 mx-6 mt-4">
                <div className="flex items-center gap-3">
                    <h2 className="text-2xl font-bold text-slate-900 tracking-tight">Units Master</h2>
                    {mode === "edit" && formState.unit_id && (
                        <span className="px-3 py-1 bg-blue-100 text-blue-700 font-mono font-bold text-sm rounded-lg border border-blue-200">
                            ID: {formState.unit_id}
                        </span>
                    )}
                </div>
                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        onClick={onClose}
                        className="group flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 shadow hover:border-sky-500 hover:bg-sky-50 hover:text-sky-600 transition-all"
                    >
                        <ChevronLeft className="h-5 w-5 transition-transform group-hover:-translate-x-1" />
                        Back
                    </button>

                </div>
            </div>

            <div className="flex-1 overflow-y-auto">
                <form onSubmit={handleSave} className="mx-auto py-4 px-4 ">
                    <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">
                        <div className="p-6 space-y-6">

                            {/* Basic Information */}
                            <div className="space-y-4">
                                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
                                    <span className="bg-slate-200 h-px flex-1"></span>
                                    Basic Information
                                </h4>
                                <div className="flex flex-col lg:flex-row gap-4">

                                    {/* Unit Images - Left Side */}
                                    <div className="w-full lg:w-64 lg:flex-shrink-0">
                                        <div className="bg-slate-50/70 border border-slate-200 rounded-2xl p-4 lg:sticky lg:top-4 h-full">
                                            <div className="flex items-center justify-between mb-2">
                                                {/* <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest flex items-center gap-1.5">
                                                    <ImageIcon size={12} />
                                                    Unit Images
                                                </span> */}
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Unit Images</label>

                                            </div>

                                            {imageData && imageData.length > 0 ? (
                                                <div className="rounded-xl overflow-hidden">
                                                    <div className="flex items-center justify-center h-60 mb-3 rounded overflow-hidden">
                                                        <img
                                                            src={getImageUrl(imageData[currentImageIndex]?.imagePath)}
                                                            alt={`Unit ${currentImageIndex + 1}`}
                                                            className="object-contain rounded-sm h-full "
                                                            key={currentImageIndex}
                                                            onError={(e) => {
                                                                console.error("Image load error");
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="text-center text-xs text-slate-500 mb-2">
                                                        Image {currentImageIndex + 1} of {imageData.length}
                                                    </div>
                                                </div>
                                            ) : uploadingImages ? (
                                                <div className="w-full h-40 rounded-xl border border-dashed border-blue-300 bg-blue-50/50 flex flex-col items-center justify-center gap-2">
                                                    <Loader2 className="w-6 h-6 text-blue-500 animate-spin" />
                                                    <span className="text-xs text-blue-500 font-medium">Uploading image...</span>
                                                </div>
                                            ) : (
                                                <button
                                                    type="button"
                                                    onClick={handleAddImage}
                                                    disabled={!formState.unit_id || uploadingImages}
                                                    className={`w-full h-40 rounded-xl border border-dashed text-xs transition-colors ${!formState.unit_id || uploadingImages ? 'border-slate-200 text-slate-300 cursor-not-allowed' : 'border-slate-300 text-slate-400 hover:border-blue-400 hover:text-blue-500'}`}
                                                >
                                                    No images yet — click to upload
                                                </button>
                                            )}

                                            <div className="flex justify-between items-center mt-3">
                                                {imageData?.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={handlePrev}
                                                        className="p-2 bg-slate-200 hover:bg-slate-300 rounded-md shadow"
                                                    >
                                                        <svg className="w-2 h-2 text-slate-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                                                    </button>
                                                )}

                                                <button
                                                    type="button"
                                                    onClick={handleAddImage}
                                                    disabled={!formState.unit_id || uploadingImages}
                                                    className={`px-2 py-1 text-white rounded transition flex justify-center items-center gap-2 text-xs font-semibold ${!formState.unit_id || uploadingImages ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-700'}`}
                                                >
                                                    {uploadingImages ? (
                                                        <Loader2 className="w-3 h-3 animate-spin" />
                                                    ) : (
                                                        <Plus className="w-3 h-3" />
                                                    )}
                                                    {uploadingImages ? 'Uploading...' : 'Add'}
                                                </button>

                                                {imageData?.length > 0 && !uploadingImages && (
                                                    <button
                                                        type="button"
                                                        onClick={handleRemoveItem}
                                                        className="px-2 py-1 text-white rounded transition flex justify-center items-center gap-2 text-xs font-semibold bg-red-500 hover:bg-red-700"
                                                    >
                                                        <Trash2 className="w-3 h-3" />
                                                        Remove
                                                    </button>
                                                )}

                                                {imageData?.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={handleNext}
                                                        className="p-2 bg-slate-200 hover:bg-slate-300 rounded-md shadow"
                                                    >
                                                        <svg className="w-2 h-2 text-slate-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                                    </button>
                                                )}
                                            </div>

                                            <p className="mt-2 text-[10px] text-slate-400 text-center">
                                                Only <span className="font-medium">JPG</span> and{" "}
                                                <span className="font-medium">PNG</span> formats are allowed!
                                            </p>
                                        </div>
                                    </div>

                                    {/* Text Fields - Right Side */}
                                    <div className="flex-1 grid grid-cols-1 md:grid-cols-4  gap-4">
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Unit Code</label>
                                            <input type="text" placeholder="A-101" value={formState.unit_code || ''} onChange={(e) => updateField('unit_code', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Unit Number</label>
                                            <input type="text" value={formState.unit_number || ''} onChange={(e) => updateField('unit_number', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Unit Name</label>
                                            <input type="text" placeholder="Apartment 405" value={formState.unit_name || ''} onChange={(e) => updateField('unit_name', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Building</label>
                                            <select value={formState.building_id || ''} onChange={(e) => updateField('building_id', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                                <option value="">Select Building</option>
                                                {buildings.map(b => <option key={b.BuildingID} value={b.BuildingID}>{b.BuildingID} ({b.BuildingName})</option>)}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Block/Tower</label>
                                            <input type="text" placeholder="Tower A" value={formState.block_tower || ''} onChange={(e) => updateField('block_tower', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Wing</label>
                                            <input type="text" placeholder="East Wing" value={formState.wing || ''} onChange={(e) => updateField('wing', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Floor</label>
                                            <input type="number" placeholder="5" value={formState.floor || ''} onChange={(e) => updateField('floor', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Property Type</label>
                                            <select value={formState.property_type || ''} onChange={(e) => updateField('property_type', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                                <option value="">Select Property Type</option>
                                                <option value="Apartment">Apartment</option>
                                                <option value="Villa">Villa</option>
                                                <option value="Office">Office</option>
                                                <option value="Shop">Shop</option>
                                                <option value="Warehouse">Warehouse</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Unit Type</label>
                                            <select value={formState.unit_type || ''} onChange={(e) => updateField('unit_type', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                                <option value="">Select Unit Type</option>
                                                <option value="Studio">Studio</option>
                                                <option value="1BHK">1BHK</option>
                                                <option value="2BHK">2BHK</option>
                                                <option value="Office">Office</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Category</label>
                                            <select value={formState.category || ''} onChange={(e) => updateField('category', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                                <option value="">Select Category</option>
                                                <option value="Residential">Residential</option>
                                                <option value="Commercial">Commercial</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Usage Type</label>
                                            <select value={formState.usageType || ''} onChange={(e) => updateField('usageType', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                                <option value="">Select Usage Type</option>
                                                <option value="Rent">Rent</option>
                                                <option value="Sale">Sale</option>
                                                <option value="Lease">Lease</option>
                                                <option value="Own">Own</option>
                                                <option value="Staff Accommodation">Staff Accommodation</option>
                                                <option value="Short Term Rental">Short Term Rental</option>
                                                <option value="Holiday Home">Holiday Home</option>
                                                <option value="Commercial">Commercial</option>
                                                <option value="Residential">Residential</option>
                                                <option value="Warehouse">Warehouse</option>
                                                <option value="Office">Office</option>
                                                <option value="Retail">Retail</option>
                                                <option value="Mixed Use">Mixed Use</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Bedrooms</label>
                                            <input type="number" placeholder="2" value={formState.bedrooms || ''} onChange={(e) => updateField('bedrooms', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Bathrooms</label>
                                            <input type="number" placeholder="3" value={formState.bathrooms || ''} onChange={(e) => updateField('bathrooms', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Unit Status</label>
                                            <select value={formState.status || ''} onChange={(e) => updateField('status', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                                <option value="">Select Status</option>
                                                <option value="Vacant">Vacant</option>
                                                <option value="Occupied">Occupied</option>
                                                <option value="Reserved">Reserved</option>
                                                <option value="Under Maintenance">Under Maintenance</option>
                                                <option value="Sold">Sold</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Plot No.</label>
                                            <input type="text" placeholder="Plot Number" value={formState.plot_no || ''} onChange={(e) => updateField('plot_no', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Unit View</label>
                                            <select value={formState.unit_view || ''} onChange={(e) => updateField('unit_view', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                                <option value="">Select Unit View</option>
                                                <option value="Sea View">Sea View</option>
                                                <option value="Partial Sea View">Partial Sea View</option>
                                                <option value="Marina View">Marina View</option>
                                                <option value="Partial Marina View">Partial Marina View</option>
                                                <option value="Canal View">Canal View</option>
                                                <option value="Partial Canal View">Partial Canal View</option>
                                                <option value="Lake View">Lake View</option>
                                                <option value="Burj Khalifa View">Burj Khalifa View</option>
                                                <option value="Downtown View">Downtown View</option>
                                                <option value="Fountain View">Fountain View</option>
                                                <option value="Skyline View">Skyline View</option>
                                                <option value="City View">City View</option>
                                                <option value="Boulevard View">Boulevard View</option>
                                                <option value="Park View">Park View</option>
                                                <option value="Garden View">Garden View</option>
                                                <option value="Pool View">Pool View</option>
                                                <option value="Courtyard View">Courtyard View</option>
                                                <option value="Golf Course View">Golf Course View</option>
                                                <option value="Community View">Community View</option>
                                                <option value="Street View">Street View</option>
                                                <option value="Road View">Road View</option>
                                                <option value="Desert View">Desert View</option>
                                                <option value="Backyard View">Backyard View</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Parking No.</label>
                                            <input type="text" placeholder="P-101" value={formState.parking_no || ''} onChange={(e) => updateField('parking_no', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Parking Count</label>
                                            <input type="number" placeholder="1" value={formState.parking_count || ''} onChange={(e) => updateField('parking_count', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Registration & Legal */}
                            <div className="space-y-4">
                                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
                                    <span className="bg-slate-200 h-px flex-1"></span>
                                    Registration & Legal
                                </h4>
                                <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">RERA Unit No.</label>
                                        <input type="text" placeholder="RERA Registration No." value={formState.rera_unit_no || ''} onChange={(e) => updateField('rera_unit_no', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Ejari Unit No.</label>
                                        <input type="text" placeholder="Ejari Registration No." value={formState.ejari_unit_no || ''} onChange={(e) => updateField('ejari_unit_no', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Title Deed No.</label>
                                        <input type="text" placeholder="Title Deed Number" value={formState.title_deed_no || ''} onChange={(e) => updateField('title_deed_no', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                </div>
                            </div>

                            {/* Area Details */}
                            <div className="space-y-4">
                                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
                                    <span className="bg-slate-200 h-px flex-1"></span>
                                    Area Details
                                </h4>
                                <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Floor Area</label>
                                        <input type="number" step="0.01" placeholder="1150.50" value={formState.floor_area || ''} onChange={(e) => updateField('floor_area', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Built-up Area</label>
                                        <input type="number" step="0.01" placeholder="1200" value={formState.built_up_area || ''} onChange={(e) => updateField('built_up_area', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Balcony Area</label>
                                        <input type="number" step="0.01" placeholder="50" value={formState.balcony_area || ''} onChange={(e) => updateField('balcony_area', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Common Area</label>
                                        <input type="number" step="0.01" placeholder="50" value={formState.common_area || ''} onChange={(e) => updateField('common_area', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Total Area</label>
                                        <input type="number" step="0.01" placeholder="1500" value={formState.total_area || ''} onChange={(e) => updateField('total_area', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Area Unit</label>
                                        <select value={formState.area_unit || ''} onChange={(e) => updateField('area_unit', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                            <option value="">Select Area Unit</option>
                                            <option value="Sq. Ft.">Sq. Ft.</option>
                                            <option value="Sq. Mtr.">Sq. Mtr.</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Rent & Sales Details */}
                            <div className="space-y-4">
                                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
                                    <span className="bg-slate-200 h-px flex-1"></span>
                                    Rent & Sales Details
                                </h4>
                                <div className="grid grid-cols-1 md:grid-cols-5 gap-4">

                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Monthly Rent (AED)</label>
                                        <input type="number" step="0.01" placeholder="8,500" value={formState.monthly_rent || ''} onChange={(e) => updateField('monthly_rent', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Annual Rent (AED)</label>
                                        <input type="number" step="0.01" placeholder="102,000" value={formState.current_rent || ''} onChange={(e) => updateField('current_rent', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Security Deposit (AED)</label>
                                        <input type="number" step="0.01" placeholder="8,500" value={formState.security_deposit || ''} onChange={(e) => updateField('security_deposit', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Service Charge</label>
                                        <input type="number" step="0.01" placeholder="12,000" value={formState.service_charge || ''} onChange={(e) => updateField('service_charge', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Rent Frequency</label>
                                        <select value={formState.payment_frequency || ''} onChange={(e) => updateField('payment_frequency', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                            <option value="">Select Frequency</option>
                                            <option value="Monthly">Monthly</option>
                                            <option value="Quarterly">Quarterly</option>
                                            <option value="Half-Yearly">Half-Yearly</option>
                                            <option value="Yearly">Yearly</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Availability Date</label>
                                        <input type="date" value={formState.availability_date || ''} onChange={(e) => updateField('availability_date', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Rental Commission %</label>
                                        <input type="number" step="0.01" placeholder="5" value={formState.rental_commission || ''} onChange={(e) => updateField('rental_commission', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Renewal Notice (Days)</label>
                                        <input type="number" placeholder="30" value={formState.renewal_notice_days || ''} onChange={(e) => updateField('renewal_notice_days', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div className="flex items-center gap-6 pt-6">
                                        <CheckboxField label="Municipality Fee Applicable" field="municipality_fee_applicable" />
                                    </div>
                                    <div className="flex items-center gap-6 pt-6">
                                        <CheckboxField label="VAT Applicable" field="vat_applicable" />
                                    </div>


                                </div>
                            </div>





                            {/* Utility Details */}
                            <div className="space-y-4">
                                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
                                    <span className="bg-slate-200 h-px flex-1"></span>
                                    Utility Details
                                </h4>
                                <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Electricity Account</label>
                                        <input type="text" placeholder="DEWA/SEWA/FEWA Account" value={formState.electricity_account || ''} onChange={(e) => updateField('electricity_account', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">DEWA No.</label>
                                        <input type="text" placeholder="DEWA-12345678" value={formState.dewa_no || ''} onChange={(e) => updateField('dewa_no', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Makani No.</label>
                                        <input type="text" placeholder="MAK-90812-7362" value={formState.makani_no || ''} onChange={(e) => updateField('makani_no', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Water Account</label>
                                        <input type="text" placeholder="Utility Account #" value={formState.water_account || ''} onChange={(e) => updateField('water_account', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Gas Account</label>
                                        <input type="text" placeholder="Gas Account #" value={formState.gas_account || ''} onChange={(e) => updateField('gas_account', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div className="flex items-center gap-6 pt-6">
                                        <CheckboxField label="Has Internet" field="has_internet" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Chiller Account</label>
                                        <input type="text" placeholder="Cooling Account #" value={formState.chiller_account || ''} onChange={(e) => updateField('chiller_account', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Chiller Type</label>
                                        <select value={formState.chiller_type || ''} onChange={(e) => updateField('chiller_type', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 cursor-pointer">
                                            <option value="">Select Chiller Type</option>
                                            <option value="Included">Included</option>
                                            <option value="Separate">Separate</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Cooling Provider</label>
                                        <input type="text" placeholder="Cooling Company Name" value={formState.cooling_provider || ''} onChange={(e) => updateField('cooling_provider', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                </div>
                            </div>

                            {/* Amenities */}
                            <div className="space-y-4">
                                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
                                    <span className="bg-slate-200 h-px flex-1"></span>
                                    Amenities
                                </h4>
                                <div className="grid grid-cols-2 md:grid-cols-7 gap-3">
                                    <CheckboxField label="Balcony" field="balcony" />
                                    <CheckboxField label="Terrace" field="terrace" />
                                    <CheckboxField label="Maid Room" field="maid_room" />
                                    <CheckboxField label="Store Room" field="store_room" />
                                    <CheckboxField label="Has Central AC" field="has_central_ac" />
                                    <CheckboxField label="Has Kitchen" field="has_kitchen" />
                                    <CheckboxField label="Has Furnished" field="has_furnished" />
                                </div>
                            </div>

                            {/* Account Settings */}
                            <div className="space-y-4">
                                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
                                    <span className="bg-slate-200 h-px flex-1"></span>
                                    Account Settings
                                </h4>
                                <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Income Account</label>
                                        <input type="text" placeholder="INC-4001" value={formState.income_account || ''} onChange={(e) => updateField('income_account', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Deposit Account</label>
                                        <input type="text" placeholder="LIA-2001" value={formState.deposit_account || ''} onChange={(e) => updateField('deposit_account', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Expense Account</label>
                                        <input type="text" placeholder="EXP-5001" value={formState.expense_account || ''} onChange={(e) => updateField('expense_account', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Cost Center</label>
                                        <input type="text" placeholder="CC-UNIT405" value={formState.cost_center || ''} onChange={(e) => updateField('cost_center', e.target.value)} className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500" />
                                    </div>
                                </div>
                            </div>

                            {/* Additional Notes */}
                            <div className="space-y-4">
                                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
                                    <span className="bg-slate-200 h-px flex-1"></span>
                                    Additional Notes
                                </h4>
                                <div>
                                    <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Notes / Remarks</label>
                                    <textarea
                                        value={formState.notes || ''}
                                        onChange={(e) => updateField('notes', e.target.value)}
                                        rows="3"
                                        placeholder="Any additional information about the unit..."
                                        className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 resize-y"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Footer Actions */}
                        <div className="bg-slate-50 border-t border-slate-100 p-4 flex items-center justify-between gap-3 flex-wrap">
                            <div className="text-xs text-slate-400">
                                {mode === "edit" ? "Updating existing unit record" : "Creating new unit record"}
                            </div>
                            <div className="flex items-center gap-3">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="px-5 py-2.5 bg-white hover:bg-slate-100 text-slate-600 font-semibold text-xs uppercase tracking-wider rounded-xl transition-all border border-slate-200 flex items-center gap-2 shadow-sm"
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="px-6 py-2.5 bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs uppercase tracking-wider rounded-xl transition-all shadow-md shadow-slate-900/10 flex items-center gap-2"
                                >
                                    <CloudUpload className="w-4 h-4" />
                                    {mode === "edit" ? "Update Entity" : "Create Unit"}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default UnitFormPage;




